/**
 * DIEUKYDIEU.TV - ONBOARDING PEEK CAROUSEL MODULE
 * Responsive swipeable cards on Home screen with ambient dynamic background.
 * Under 300 lines rule compliant.
 */

import { t } from './i18n.js';
import { state } from './state.js';
import { openWebStory } from './web-story.js';
import { storyApi } from './api/story.api.js';

// 5 chu de cau chuyen ky dieu tai cac tinh thanh
export const CAROUSEL_TOPICS = [
    { id: 'hue', key: 'card_hue', promptKey: 'prompt_hue', name: 'Huế', prompt: 'Điều kỳ diệu ở Huế', colorRGB: '147, 51, 234', img: 'https://images.unsplash.com/photo-1599707367072-cd6ada2bc375?auto=format&fit=crop&w=800&q=85' },
    { id: 'danang', key: 'card_danang', promptKey: 'prompt_danang', name: 'Đà Nẵng', prompt: 'Điều kỳ diệu ở Đà Nẵng', colorRGB: '14, 165, 233', img: 'https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?auto=format&fit=crop&w=800&q=85' },
    { id: 'binhdinh', key: 'card_binhdinh', promptKey: 'prompt_binhdinh', name: 'Bình Định', prompt: 'Điều kỳ diệu ở Bình Định', colorRGB: '245, 158, 11', img: 'https://images.unsplash.com/photo-1589308078059-be1415eab4c3?auto=format&fit=crop&w=800&q=85' },
    { id: 'vungtau', key: 'card_vungtau', promptKey: 'prompt_vungtau', name: 'Vũng Tàu', prompt: 'Điều kỳ diệu ở Vũng Tàu', colorRGB: '37, 99, 235', img: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=800&q=85' },
    { id: 'bentre', key: 'card_bentre', promptKey: 'prompt_bentre', name: 'Bến Tre', prompt: 'Điều kỳ diệu ở Bến Tre', colorRGB: '16, 185, 129', img: 'https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&w=800&q=85' }
];

export let activeTopics = [...CAROUSEL_TOPICS];
let isTopicsLoaded = false;

export async function loadCarouselTopics() {
    try {
        const topics = await storyApi.getStoryTopics();
        if (Array.isArray(topics) && topics.length > 0) {
            activeTopics = topics.map(item => ({
                id: item.id, key: item.key || `card_${item.id}`, promptKey: item.promptKey || `prompt_${item.id}`,
                name: item.name || item.title, prompt: item.prompt || item.desc, colorRGB: item.colorRGB || '147, 51, 234',
                img: item.img || item.coverImg || item.cover_img
            }));
            renderCarousel();
        }
    } catch (_) {}
}

let currentCarouselIndex = 0, carouselCurrentTranslate = 0, carouselTargetTranslate = 0;
let carouselIsDragging = false, carouselHasDragged = false, carouselStartX = 0, carouselStartY = 0;
let carouselCurrentX = 0, carouselDragDiffX = 0, carouselStartTime = 0, carouselIsHorizSwipe = null, carouselEventsAttached = false;

export function renderCarousel() {
    if (!isTopicsLoaded) {
        isTopicsLoaded = true;
        loadCarouselTopics();
    }
    const container = document.getElementById('topics-carousel');
    if (!container) return;

    let track = document.getElementById('carousel-track');
    if (!track) {
        track = document.createElement('div');
        track.className = 'carousel-track';
        track.id = 'carousel-track';
        container.appendChild(track);
    }
    track.innerHTML = '';

    const dotsContainer = document.getElementById('carousel-dots-container');
    if (dotsContainer) dotsContainer.innerHTML = '';

    activeTopics.forEach((item, index) => {
        const card = document.createElement('div');
        card.className = `carousel-card ${index === currentCarouselIndex ? 'active' : ''}`;
        card.setAttribute('data-index', index);
        card.setAttribute('tabindex', '0');
        card.setAttribute('role', 'button');
        const titleText = (state.currentLang === 'vi' && item.name) ? item.name : (t(item.key) || item.name);
        card.setAttribute('aria-label', titleText);
        card.innerHTML = `
            <div class="card-image-box" style="background-image: url('${item.img}')"></div>
            <div class="card-details-box">
                <h3 class="card-title">${titleText}</h3>
                <button class="card-cta-btn" onclick="exploreFromTopic('${item.id}', event)">
                    <span>${t('explore_now')}</span>
                </button>
            </div>
        `;
        card.onclick = (e) => {
            if (carouselHasDragged) return;
            const isDesktop = window.innerWidth > 1024;
            if (!isDesktop && index !== currentCarouselIndex) {
                currentCarouselIndex = index;
                updateCarousel(true);
            } else {
                exploreFromTopic(item.id, e);
            }
        };
        track.appendChild(card);

        if (dotsContainer) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = `carousel-dot ${index === currentCarouselIndex ? 'active' : ''}`;
            dot.setAttribute('aria-label', titleText);
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-selected', index === currentCarouselIndex ? 'true' : 'false');
            dot.onclick = () => { currentCarouselIndex = index; updateCarousel(true); };
            dotsContainer.appendChild(dot);
        }
    });

    initCarouselControls();
    updateCarousel(false);
}

export function updateCarousel(smooth = true) {
    const container = document.getElementById('topics-carousel');
    const track = document.getElementById('carousel-track');
    if (!container || !track) return;

    const cards = track.querySelectorAll('.carousel-card');
    const dots = document.querySelectorAll('.carousel-dot');
    if (!cards.length) return;

    currentCarouselIndex = Math.max(0, Math.min(activeTopics.length - 1, currentCarouselIndex));
    const activeCard = cards[currentCarouselIndex];
    if (!activeCard) return;

    const isDesktop = window.innerWidth > 1024;
    const containerWidth = container.offsetWidth;
    const trackWidth = track.scrollWidth;
    const cardWidth = activeCard.offsetWidth;
    const cardLeft = activeCard.offsetLeft;

    let targetOffset = 0;
    if (isDesktop) {
        if (trackWidth <= containerWidth) {
            targetOffset = (containerWidth - trackWidth) / 2;
            container.classList.remove('has-overflow');
        } else {
            const idealOffset = (containerWidth - cardWidth) / 2 - cardLeft;
            const maxScroll = trackWidth - containerWidth;
            targetOffset = Math.max(-maxScroll, Math.min(0, idealOffset));
            container.classList.add('has-overflow');
        }
    } else {
        targetOffset = (containerWidth - cardWidth) / 2 - cardLeft;
        container.classList.add('has-overflow');
    }

    carouselTargetTranslate = targetOffset;
    carouselCurrentTranslate = targetOffset;

    track.classList.toggle('no-transition', !smooth);
    track.style.transform = `translate3d(${targetOffset}px, 0, 0)`;
    if (!smooth) { void track.offsetHeight; track.classList.remove('no-transition'); }

    cards.forEach((card, idx) => {
        const isActive = idx === currentCarouselIndex;
        card.classList.toggle('active', isActive);
        card.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    dots.forEach((dot, idx) => {
        const isActive = idx === currentCarouselIndex;
        dot.classList.toggle('active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    const prevBtn = document.getElementById('carousel-prev-btn');
    const nextBtn = document.getElementById('carousel-next-btn');
    if (prevBtn) prevBtn.disabled = currentCarouselIndex === 0;
    if (nextBtn) nextBtn.disabled = currentCarouselIndex >= activeTopics.length - 1;

    const bgLayer = document.getElementById('dynamic-bg');
    const activeData = activeTopics[currentCarouselIndex] || CAROUSEL_TOPICS[currentCarouselIndex];
    if (bgLayer && activeData) {
        bgLayer.style.backgroundImage = `radial-gradient(circle at 20% 35%, rgba(${activeData.colorRGB}, 0.35), transparent 60%), radial-gradient(circle at 80% 65%, rgba(${activeData.colorRGB}, 0.25), transparent 60%)`;
    }
    const headingEl = document.getElementById('home-heading');
    if (headingEl && activeData) {
        const dynamicPrompt = activeData.prompt || activeData.desc;
        const promptText = (state.currentLang === 'vi' && dynamicPrompt)
            ? dynamicPrompt
            : (t(activeData.promptKey) || dynamicPrompt || `Điều kỳ diệu ở ${activeData.name}`);
        if (headingEl.textContent !== promptText) headingEl.textContent = promptText;
    }
}

export function exploreFromTopic(topicId, e) {
    if (e) e.stopPropagation();
    if (carouselHasDragged) return;
    const topic = activeTopics.find(t => t.id === topicId) || CAROUSEL_TOPICS.find(t => t.id === topicId);
    if (!topic) return;
    openWebStory(topic.id);
}

export function initCarouselControls() {
    const container = document.getElementById('topics-carousel');
    const track = document.getElementById('carousel-track');
    const prevBtn = document.getElementById('carousel-prev-btn');
    const nextBtn = document.getElementById('carousel-next-btn');

    if (prevBtn) {
        prevBtn.onclick = (e) => {
            e.stopPropagation();
            if (currentCarouselIndex > 0) { currentCarouselIndex--; updateCarousel(true); }
        };
    }
    if (nextBtn) {
        nextBtn.onclick = (e) => {
            e.stopPropagation();
            if (currentCarouselIndex < CAROUSEL_TOPICS.length - 1) { currentCarouselIndex++; updateCarousel(true); }
        };
    }

    if (!container || !track || carouselEventsAttached) return;
    carouselEventsAttached = true;

    const onPointerDown = (e) => {
        if (e.button !== undefined && e.button !== 0) return;
        carouselIsDragging = true;
        carouselHasDragged = false;
        carouselStartX = carouselCurrentX = e.clientX;
        carouselStartY = e.clientY;
        carouselDragDiffX = 0;
        carouselStartTime = Date.now();
        carouselIsHorizSwipe = null;
        track.classList.add('no-transition');
        container.classList.add('is-dragging');
    };

    const onPointerMove = (e) => {
        if (!carouselIsDragging) return;
        carouselCurrentX = e.clientX;
        carouselDragDiffX = carouselCurrentX - carouselStartX;
        const diffY = e.clientY - carouselStartY;
        const moveThreshold = e.pointerType === 'mouse' ? 16 : 8;

        if (carouselIsHorizSwipe === null) {
            if (Math.abs(diffY) > Math.abs(carouselDragDiffX) && Math.abs(diffY) > 8) {
                carouselIsDragging = false;
                track.classList.remove('no-transition');
                container.classList.remove('is-dragging');
                try { container.releasePointerCapture(e.pointerId); } catch (_) {}
                return;
            } else if (Math.abs(carouselDragDiffX) > moveThreshold) {
                carouselIsHorizSwipe = true;
                try { container.setPointerCapture(e.pointerId); } catch (_) {}
            }
        }

        if (carouselIsHorizSwipe) {
            if (Math.abs(carouselDragDiffX) > moveThreshold) {
                carouselHasDragged = true;
            }
            let appliedDiff = carouselDragDiffX;
            if ((currentCarouselIndex === 0 && carouselDragDiffX > 0) ||
                (currentCarouselIndex === CAROUSEL_TOPICS.length - 1 && carouselDragDiffX < 0)) {
                appliedDiff = carouselDragDiffX * 0.32;
            }
            track.style.transform = `translate3d(${carouselTargetTranslate + appliedDiff}px, 0, 0)`;
        }
    };

    const onPointerUp = (e) => {
        if (!carouselIsDragging) return;
        carouselIsDragging = false;
        track.classList.remove('no-transition');
        container.classList.remove('is-dragging');
        try { container.releasePointerCapture(e.pointerId); } catch (_) {}

        const duration = Math.max(1, Date.now() - carouselStartTime);
        const velocity = Math.abs(carouselDragDiffX) / duration;
        const moveThreshold = e.pointerType === 'mouse' ? 16 : 8;
        if (Math.abs(carouselDragDiffX) <= moveThreshold) carouselHasDragged = false;

        if (carouselDragDiffX < -45 || (carouselDragDiffX < -18 && velocity > 0.32)) {
            if (currentCarouselIndex < activeTopics.length - 1) currentCarouselIndex++;
        } else if (carouselDragDiffX > 45 || (carouselDragDiffX > 18 && velocity > 0.32)) {
            if (currentCarouselIndex > 0) currentCarouselIndex--;
        }
        updateCarousel(true);
        if (carouselHasDragged) setTimeout(() => { carouselHasDragged = false; }, 80);
    };

    container.addEventListener('pointerdown', onPointerDown);
    container.addEventListener('pointermove', onPointerMove);
    container.addEventListener('pointerup', onPointerUp);
    container.addEventListener('pointercancel', onPointerUp);
    container.addEventListener('pointerleave', () => {
        if (carouselIsDragging && !carouselIsHorizSwipe) {
            carouselIsDragging = false;
            track.classList.remove('no-transition');
            container.classList.remove('is-dragging');
        }
    });

    document.addEventListener('keydown', (e) => {
        if (state.currentView !== 'home-view') return;
        if (document.activeElement && (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA')) return;
        if (e.key === 'ArrowLeft' && currentCarouselIndex > 0) {
            currentCarouselIndex--;
            updateCarousel(true);
        } else if (e.key === 'ArrowRight' && currentCarouselIndex < activeTopics.length - 1) {
            currentCarouselIndex++;
            updateCarousel(true);
        }
    });
}
